export default __webpack_public_path__ + "static/media/Spin general_Interactive LightMix0019.7e9bb57d.webp";